import { render } from "./factoryStatistics.vue?vue&type=template&id=d8456816&scoped=true"
import script from "./factoryStatistics.vue?vue&type=script&lang=js"
export * from "./factoryStatistics.vue?vue&type=script&lang=js"

import "./factoryStatistics.vue?vue&type=style&index=0&id=d8456816&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8456816"]])

export default __exports__